<script setup lang="ts">
    import FloatLabel from 'primevue/floatlabel';
    import Message from 'primevue/message';
    import { ref, type Ref } from 'vue';
    import { componentStyle } from '@/styling/util/component-style.ts';
    import type { MessageDesignTokens } from '@primeuix/themes/types/message';

    defineProps<{
        label: string;
        errorMessage?: string;
        preClaimErrorSpace?: boolean;
        required?: boolean;
    }>();

    const containerRef = ref(null);

    const inputRef = ref();
    const messageStyle = componentStyle<MessageDesignTokens>({
        text: {
            fontWeight: '400',
        },
    });

    function setInputRef(newRef: Ref<unknown>): void {
        inputRef.value = newRef;
    }

    defineExpose({
        innerRef: containerRef,
    });
</script>

<template>
    <div ref="containerRef" class="form-field-container">
        <FloatLabel variant="in">
            <slot :ref="setInputRef" />
            <label :for="inputRef">{{ label }}{{ required ? '*' : '' }} </label>
        </FloatLabel>
        <Message
            v-if="(errorMessage != null && errorMessage !== '') || preClaimErrorSpace"
            :class="{ 'text-sm-regular-line-height-auto': preClaimErrorSpace, 'pre-claim': preClaimErrorSpace }"
            :dt="messageStyle"
            severity="error"
            size="small"
            variant="simple"
            >{{ errorMessage }}
        </Message>
    </div>
</template>

<style scoped lang="scss">
    @use '@/styling/main';

    .form-field-container {
        padding-top: main.$spacing-5;

        .pre-claim {
            margin-top: 2px;
            min-height: 14.7px;
        }
    }
</style>
